import React from "react";

// Section A, "What I've read". Strictly read-only: no input of any kind, no counter,
// no call to action beyond going back. Its whole job is to show the participant that
// their material has actually been read before anyone asks them for more.
//
// Content lives in `read_blocks` and is published one block at a time by the operator,
// which is what lets the portfolio numbers stay dark until the workshop opens them.

export default function ReadSection({ blocks, participant, onBack }) {
  const first = (participant?.full_name || "").split(" ")[0];

  const groups = [];
  for (const b of blocks) {
    const last = groups[groups.length - 1];
    if (last && last.category === b.category) last.blocks.push(b);
    else groups.push({ category: b.category, blocks: [b] });
  }

  return (
    <div className="readpage">
      <div className="quest__nav">
        <button className="link-btn" onClick={onBack}>← Back to the dashboard</button>
      </div>

      <div className="cover"><img src="/img/band1.jpg" alt="" /></div>

      <div className="readpage__head">
        <div className="dash__eyebrow">Before we meet</div>
        <h1 className="dash__title">What I've read, {first}</h1>
        <p className="qf-lead">
          Your decks, your LP report, your article, your podcasts, your activity export, and
          thirty other funds' positioning. Nothing to fill in here. This is just so you know
          what I'm working from on Tuesday.
        </p>
      </div>

      {groups.map((g) => (
        <section className="readpage__group" key={g.category}>
          <div className="section__label">{g.category}</div>
          <div className="qf-stack--lg readpage__blocks">
            {g.blocks.map((b) => (
              <div className="qf-card readblock" key={b.id}>
                {b.title && <h2 className="readblock__title">{b.title}</h2>}
                {(b.body || "").split(/\n\s*\n/).filter(Boolean).map((para, i) => (
                  <p className="readblock__body" key={i}>{para}</p>
                ))}
                {b.source_note && <div className="readblock__source">{b.source_note}</div>}
              </div>
            ))}
          </div>
        </section>
      ))}

      <div className="quest__foot">
        <button className="qf-btn qf-btn--primary" onClick={onBack}>Back to the dashboard</button>
      </div>
    </div>
  );
}
